
import Modal from "@/components/Modal.vue";
import { apiCall } from "@/lib/api";
import { Component, MixedVue } from "@/vue";
import { Prop, Ref } from "vue-property-decorator";
import { Farm } from "@/lib/types/Farm";
import { SupportedCountries, supportedCountyNames } from "@/lib/supported-countries";

@Component({
  name: "UpdateFarmModal",
  components: { Modal },
})
export default class UpdateFarmModal extends MixedVue {
  static components: {
    Modal: typeof Modal;
  };

  @Prop({ type: Object, required: false, default: null })
  farm: Farm;

  @Ref()
  modal: Modal;

  name = "";

  errors = {
    error: "",
    name: "",
  };

  get headerText() {
    if (this.farm) return this.$gettext("Edit your farm");
    return this.$gettext("Add your farm");
  }
  get buttonText() {
    if (this.farm) return this.$gettext("Save changes");
    return this.$gettext("Add farm");
  }

  mounted() {
    if (this.farm) {
      this.name = this.getFarmName(this.farm);
    }
  }

  async createOrUpdateFarm() {
    const data = { name: this.name };
    let method: string, endpoint: string, eventName: string;

    if (this.farm) {
      method = "PATCH";
      endpoint = `/farm/${this.farm.id}/`;
      eventName = "FARM_EDITED";
    } else {
      method = "POST";
      endpoint = `/farm/`;
      eventName = "FARM_CREATED";
    }

    try {
      const response = await apiCall<Farm>(method, endpoint, {}, data);
      this.modal.closeModal();
      await this.$store.dispatch("getFarms");
      if (method === "POST" && this.isMobile) {
        await this.$router.push({
          name: "choose-import-type",
          params: {
            farmId: response.id,
          },
        });
      } else if (method === "POST") {
        await this.$router.push({
          name: "manage-farm",
          params: {
            farmId: response.id,
          },
        });
      }
    } catch (reason) {
      this.setErrors(reason);
    }
  }
}
